var $ = require('jquery');

export default {

  inIFrame: function () {
    return (window.self != window.top);
  },

  inHiddenIFrame: function () {
    var $window = $(window);

    return (this.inIFrame() && !$window.height());
  },

};
